var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.isCargando}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":70,"width":7}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }